module.exports = __webpack_public_path__ + "media/android-di-sdk.5f4bb471.mp4";